// extracted by mini-css-extract-plugin
export default {"donutchartTrack":"Z3fJLyw9DMrd5iHPLjxL","donutchartIndicator":"LCSGMWY_wtWZlHo4puwP","donutchart":"oooSRuwge2V1scetSSY5"};